import { CheckCircle2, CircleAlert } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { missingFields } from "@/lib/format";

export const TrStatus = ({ rec, fields, t, testid }) => {
  const m = missingFields(rec, fields);
  if (!m.en.length && !m.ar.length) {
    return <span data-testid={testid} className="inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[11px] font-semibold text-emerald-300"><CheckCircle2 className="h-3 w-3" />{t("tr.complete")}</span>;
  }
  return (
    <span data-testid={testid} className="flex flex-wrap gap-1">
      {["en", "ar"].filter((l) => m[l].length).map((l) => (
        <span key={l} data-testid={`${testid}-${l}`} className="inline-flex items-center gap-1 rounded-full bg-amber-500/15 px-2 py-0.5 text-[11px] font-semibold text-amber-300">
          <CircleAlert className="h-3 w-3" />{t(`tr.missing_${l}`)}: {m[l].map((f) => t(`field.${f}`)).join("، ")}
        </span>
      ))}
    </span>
  );
};

export function BilingualFields({ form, set, fields, t, testPrefix, errors = {} }) {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      {["en", "ar"].map((l) => {
        const missing = fields.filter((f) => !(form[`${f.key}_${l}`] || "").trim()).length;
        return (
          <div key={l} dir={l === "ar" ? "rtl" : "ltr"} lang={l} className="space-y-3 rounded-xl border bg-secondary/30 p-4" data-testid={`${testPrefix}-${l}-panel`}>
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm font-bold">{l === "en" ? "English" : "العربية"}</span>
              <span className={`text-[11px] font-semibold ${missing ? "text-amber-300" : "text-emerald-300"}`}>{missing ? t("tr.nMissing", { n: missing }) : t("tr.allDone")}</span>
            </div>
            {fields.map((f) => {
              const k = `${f.key}_${l}`;
              const empty = !(form[k] || "").trim();
              const C = f.multiline ? Textarea : Input;
              return (
                <div key={k} className="space-y-1.5">
                  <div className="flex items-center justify-between">
                    <Label htmlFor={`${testPrefix}-${k}`}>{t(`field.${f.key}`)}</Label>
                    {empty && <span className="text-[11px] font-semibold text-amber-300" data-testid={`${testPrefix}-${k}-missing`}>{t("tr.missingField")}</span>}
                  </div>
                  <C id={`${testPrefix}-${k}`} value={form[k] || ""} onChange={(e) => set(k, e.target.value)} rows={f.multiline ? 4 : undefined} maxLength={f.multiline ? 1500 : 150}
                    data-testid={`${testPrefix}-${k}`} className={errors[f.key] ? "border-destructive" : empty ? "border-amber-500/40" : ""} />
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
